import { useEffect, useState } from 'react';

export function useGetBpSessionId() {
  const [bpId, setBpId] = useState('');
  useEffect(() => {
    const bpMetaTag = document.querySelector('meta[name="bp-server-session-id"]');
    if (bpMetaTag) {
      setBpId(bpMetaTag.getAttribute('content') ?? '');
    } else {
      setBpId('');
    }
  }, []);

  return bpId;
}
